import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n                        Contract Details\n                    ")
], -1);
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_5 = { class: "col-span-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "contractType",
    class: "block text-sm font-medium text-gray-70"
}, "Contract Type: *", -1);
const _hoisted_7 = ["value", "disabled"];
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "col-span-6" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "contractLevel",
    class: "block text-sm font-medium text-gray-70"
}, "Contract Level: *", -1);
const _hoisted_11 = ["value", "disabled"];
const _hoisted_12 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_13 = ["for"];
const _hoisted_14 = ["id", "value", "name", "disabled"];
const _hoisted_15 = {
    key: 0,
    class: "p-3 w-full flex flex-row items-center"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 ml-2" }, "\n                    Once submitted, this document will go for re-approval because the terms have changed.\n                  ", -1);
const _hoisted_17 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6 flex justify-end items-center"
};
const _hoisted_18 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "select-contract-type",
                                value: _ctx.formData?.contractType,
                                name: "contractType",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:text-gray-600 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm,
                                onChange: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.contractType.$touch()))
                            }, [
                                (_ctx.disableForm)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.configItems.CONTRACTS, (contract) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: contract.ContractType
                                        }, _toDisplayString(contract.ContractType), 1));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContractTypes, (contract) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: contract.ContractType
                                        }, _toDisplayString(contract.ContractType), 1));
                                    }), 128))
                            ], 40, _hoisted_7),
                            _createTextVNode(),
                            (_ctx.v$.formData.contractType.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                              * " + _toDisplayString(_ctx.v$.formData.contractType.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "select-contract-level",
                                value: _ctx.formData?.contractLevel,
                                name: "contractLevel",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:text-gray-600 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm,
                                onChange: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.contractLevel.$touch()))
                            }, [
                                (_ctx.disableForm)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentContractType?.Items, (contract) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: contract.ID
                                        }, _toDisplayString(contract.ContractName), 1));
                                    }), 128))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.activeContracts, (contract) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: contract.ID
                                        }, _toDisplayString(contract.ContractName), 1));
                                    }), 128))
                            ], 40, _hoisted_11),
                            _createTextVNode(),
                            (_ctx.v$.formData.contractLevel.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "\n                              * " + _toDisplayString(_ctx.v$.formData.contractLevel.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailsFields, (cd) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: cd.index,
                                class: "col-span-6"
                            }, [
                                _createElementVNode("label", {
                                    for: cd.index,
                                    class: "block text-sm font-medium text-gray-70"
                                }, _toDisplayString(cd.label), 9, _hoisted_13),
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    id: `select-${cd.index}`,
                                    value: _ctx.formData[cd.index],
                                    name: cd.index,
                                    type: "text",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:text-gray-600 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onChange: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_14)
                            ]));
                        }), 128))
                    ])
                ]),
                _createTextVNode(),
                (_ctx.hasChanged)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_ExclamationIcon, { class: "text-red-600 h-16 w-16" }),
                        _createTextVNode(),
                        _hoisted_16
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createTextVNode(),
        (_ctx.editable || (!_ctx.disableForm && _ctx.document.currentStageName === 'offer.notifyPrepOffer'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "ml-4 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                }, "\n              Save\n          ", 8, _hoisted_18)
            ]))
            : _createCommentVNode("", true)
    ]));
}
